/* LISSOME JP shared runtime (vanilla, no deps). Loaded by sections/lj-header.liquid with defer.
   Sections call window.LJ helpers from their own <script> (wrap in LJ.ready). */
(function () {
  'use strict';
  var LJ = window.LJ = window.LJ || {};
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  LJ.reduced = function () { return reduced.matches; };
  LJ.mq = function (px) { return window.matchMedia('(max-width: ' + px + 'px)'); };
  LJ.ready = function (fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); };
  LJ.qs = function (sel, root) { return (root || document).querySelector(sel); };
  LJ.qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  LJ.inView = function (el, pad) { if (!el) return false; var r = el.getBoundingClientRect(), p = pad || 0; return r.bottom > -p && r.top < window.innerHeight + p; };

  /* ---- scroll reveal: any [data-reveal] gets .is-in when 15% visible ---- */
  LJ.reveal = function (root) {
    var els = LJ.qsa('[data-reveal]:not(.is-in)', root);
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduced.matches) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (e) { io.observe(e); });
  };

  /* ---- videos: <video data-lj-autoplay> play only while on screen ---- */
  /* videos carry data-src (no src) until they are near the viewport: nothing downloads on page load */
  LJ.loadVideo = function (v) { var s = v && v.getAttribute('data-src'); if (s) { v.removeAttribute('data-src'); v.src = s; } };
  LJ.lazyVideos = function (root) {
    var vids = LJ.qsa('video[data-src]', root);
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(LJ.loadVideo); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { LJ.loadVideo(e.target); io.unobserve(e.target); } }); }, { rootMargin: '600px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  };
  LJ.autoplay = function (root) {
    var vids = LJ.qsa('video[data-lj-autoplay]', root);
    if (!vids.length) return;
    function sync() {
      vids.forEach(function (v) {
        var on = LJ.inView(v, 120) && !document.hidden && !reduced.matches && !v.hasAttribute('data-lj-paused');
        if (on) { LJ.loadVideo(v); if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
        else if (!v.paused) v.pause();
      });
    }
    var raf = null;
    var tick = function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; sync(); }); };
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    document.addEventListener('visibilitychange', sync);
    sync();
    return sync;
  };

  /* ---- tabs: root[data-lj-tabs] > [data-lj-tab="k"] buttons + [data-lj-panel="k"] panels ---- */
  LJ.tabs = function (root, onChange) {
    var tabs = LJ.qsa('[data-lj-tab]', root), panels = LJ.qsa('[data-lj-panel]', root);
    function go(k) {
      tabs.forEach(function (t) { var a = t.getAttribute('data-lj-tab') === k; t.classList.toggle('is-active', a); t.setAttribute('aria-selected', a ? 'true' : 'false'); if (t.hasAttribute('role')) t.tabIndex = a ? 0 : -1; });
      panels.forEach(function (p) { var a = p.getAttribute('data-lj-panel') === k; p.classList.toggle('is-active', a); if (p.hasAttribute('data-lj-hide')) p.hidden = !a; });
      root.setAttribute('data-lj-active', k);
      if (onChange) onChange(k);
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { go(t.getAttribute('data-lj-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var i = tabs.indexOf(t), n = tabs.length, d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
        var nt = tabs[(i + d + n) % n]; e.preventDefault(); nt.focus(); go(nt.getAttribute('data-lj-tab'));
      });
    });
    var init = root.getAttribute('data-lj-active') || (tabs[0] && tabs[0].getAttribute('data-lj-tab'));
    if (init != null) go(init);
    return go;
  };

  /* ---- accordion: [data-lj-acc] button controls the element whose id is aria-controls ---- */
  LJ.accordion = function (root, single) {
    var btns = LJ.qsa('[data-lj-acc]', root);
    btns.forEach(function (b) {
      var panel = document.getElementById(b.getAttribute('aria-controls'));
      if (!panel) return;
      var open = b.getAttribute('aria-expanded') === 'true';
      panel.hidden = !open;
      b.addEventListener('click', function () {
        var now = b.getAttribute('aria-expanded') === 'true';
        if (single) btns.forEach(function (o) { if (o !== b) { o.setAttribute('aria-expanded', 'false'); var p = document.getElementById(o.getAttribute('aria-controls')); if (p) p.hidden = true; o.classList.remove('is-open'); } });
        b.setAttribute('aria-expanded', now ? 'false' : 'true'); b.classList.toggle('is-open', !now); panel.hidden = now;
      });
    });
  };

  /* ---- dialog: LJ.dialog(el) -> {open(trigger), close()} ; Esc + backdrop close, focus returns ---- */
  LJ.dialog = function (el) {
    var last = null;
    function close() { el.hidden = true; document.body.classList.remove('lj-lock'); document.removeEventListener('keydown', onKey); if (last && last.focus) last.focus(); el.dispatchEvent(new CustomEvent('lj:close')); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    function open(trigger) { last = trigger || document.activeElement; el.hidden = false; document.body.classList.add('lj-lock'); document.addEventListener('keydown', onKey); var f = el.querySelector('[data-lj-autofocus],button,a,[tabindex]'); if (f) f.focus(); el.dispatchEvent(new CustomEvent('lj:open')); }
    el.addEventListener('click', function (e) { if (e.target === el || e.target.hasAttribute('data-lj-close')) close(); });
    return { open: open, close: close };
  };

  /* ---- quantity stepper: root[data-lj-qty] with input[name=quantity], [data-lj-minus], [data-lj-plus] ---- */
  LJ.qty = function (root) {
    var input = LJ.qs('input[name="quantity"]', root), minus = LJ.qs('[data-lj-minus]', root), plus = LJ.qs('[data-lj-plus]', root), out = LJ.qs('[data-lj-qty-out]', root);
    if (!input) return;
    var min = parseInt(input.min || '1', 10), max = parseInt(input.max || '9', 10);
    function set(v) { v = Math.max(min, Math.min(max, v | 0)); input.value = v; if (out) out.textContent = v; if (minus) minus.disabled = v <= min; if (plus) plus.disabled = v >= max; }
    if (minus) minus.addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
    input.addEventListener('change', function () { set(parseInt(input.value, 10) || min); });
    set(parseInt(input.value, 10) || min);
  };

  /* ---- cart badge: fetch /cart.js and show count in every [data-shopify-cart-count] ---- */
  LJ.cartCount = function (known) {
    var badges = LJ.qsa('[data-shopify-cart-count]');
    if (!badges.length) return;
    function paint(n) { badges.forEach(function (b) { b.textContent = n; b.style.display = n > 0 ? 'block' : 'none'; }); }
    if (typeof known === 'number') { paint(known); return; }
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      paint(c && c.item_count ? c.item_count : 0);
    }).catch(function () {});
  };

  /* ---- horizontal snap carousel: root[data-lj-rail] (scroll container) + [data-lj-prev]/[data-lj-next]/[data-lj-dot=i] ---- */
  LJ.rail = function (root, opts) {
    opts = opts || {};
    var rail = LJ.qs('[data-lj-rail]', root) || root, items = LJ.qsa('[data-lj-item]', rail), dots = LJ.qsa('[data-lj-dot]', root), prev = LJ.qs('[data-lj-prev]', root), next = LJ.qs('[data-lj-next]', root), idx = 0, timer = null;
    function paint() {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === idx); });
      root.setAttribute('data-lj-index', idx);
      if (opts.onChange) opts.onChange(idx);
    }
    function go(i, smooth) { if (!items.length) return; idx = ((i % items.length) + items.length) % items.length; var it = items[idx]; rail.scrollTo({ left: it.offsetLeft - (rail.clientWidth - it.clientWidth) / 2, behavior: smooth === false || reduced.matches ? 'auto' : 'smooth' }); paint(); }
    function arm() { if (!opts.auto || reduced.matches) return; clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, opts.auto); }
    if (prev) prev.addEventListener('click', function () { go(idx - 1); arm(); });
    if (next) next.addEventListener('click', function () { go(idx + 1); arm(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); arm(); }); });
    var st = null;
    rail.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { var c = rail.scrollLeft + rail.clientWidth / 2, best = 0, bd = 1e9; items.forEach(function (it, i) { var d = Math.abs(it.offsetLeft + it.clientWidth / 2 - c); if (d < bd) { bd = d; best = i; } }); if (best !== idx) { idx = best; paint(); } }, 80); }, { passive: true });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', arm);
    paint(); arm();
    return { go: go, index: function () { return idx; }, stop: function () { clearInterval(timer); }, start: arm };
  };

  /* ---- header: transparent over hero, solid after scroll; mobile menu ---- */
  LJ.header = function () {
    var h = LJ.qs('.lj-header'); if (!h) return;
    var solidAlways = h.hasAttribute('data-lj-solid');
    var thr = h.getAttribute('data-lj-threshold') || '0';
    function limit() { return thr === 'vh70' ? window.innerHeight * 0.7 : parseFloat(thr) || 0; }
    function onScroll() { h.classList.toggle('is-scrolled', solidAlways || window.scrollY > limit()); }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    var menu = LJ.qs('.lj-menu'), openBtn = LJ.qs('[data-lj-menu-open]'), closeBtn = LJ.qs('[data-lj-menu-close]');
    if (menu && openBtn) {
      var d = LJ.dialog(menu);
      openBtn.addEventListener('click', function () { d.open(openBtn); openBtn.setAttribute('aria-expanded', 'true'); });
      menu.addEventListener('lj:close', function () { openBtn.setAttribute('aria-expanded', 'false'); });
      if (closeBtn) closeBtn.addEventListener('click', d.close);
      LJ.qsa('a', menu).forEach(function (a) { a.addEventListener('click', d.close); });
    }
  };

  /* ---- Concept cart drawer: our own close button (its built-in one never paints on iPhone WebKit) ---- */
  LJ.cartDrawerClose = function () {
    var cd = document.querySelector('cart-drawer'); if (!cd) return;
    var inner = cd.querySelector(':scope > .drawer__inner'); if (!inner || inner.querySelector('.lj-cart-close')) return;
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'lj-cart-close'; btn.setAttribute('aria-label', 'カートを閉じる');
    btn.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5 15L15 5M5 5L15 15"/></svg>';
    btn.addEventListener('click', function () { if (typeof cd.hide === 'function') cd.hide(); else cd.removeAttribute('open'); });
    inner.appendChild(btn);
  };

  LJ.ready(function () {
    document.body.classList.add('lj-body');
    LJ.cartDrawerClose();
    LJ.header();
    LJ.reveal();
    LJ.lazyVideos();
    LJ.autoplay();
    LJ.cartCount();
    document.addEventListener('lj:cart-updated', LJ.cartCount);
    document.addEventListener('ajaxProduct:added', function () { if (!(window.theme && theme.pubsub)) setTimeout(LJ.cartCount, 300); });
    if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) { try { theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (ev) { var c = ev && ev.cart; if (c && typeof c.item_count === 'number') { LJ.cartCount(c.item_count); } else { setTimeout(LJ.cartCount, 150); } }); } catch (e) {} }
  });
})();
/* JP site has no collection pages: Concept's "continue shopping" links (/collections/all) go home instead (2026-10-08) */
(function(){function fix(){document.querySelectorAll('a[href="/collections/all"],a[href^="/collections/all?"],a[href$="/collections/all"]').forEach(function(a){a.setAttribute('href','/');});}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fix);}else{fix();}
document.addEventListener('cart:refresh',fix);document.addEventListener('lj:cart-updated',fix);new MutationObserver(function(){fix();}).observe(document.documentElement,{childList:true,subtree:true});})();
/* Order note: inline textarea in the cart drawer (saves to cart.note, survives drawer re-renders); plain placeholder on the /cart page (2026-10-09) */
(function(){var TEXT=null,timer=null;
function save(ta,hint){var v=ta.value;TEXT=v;fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({note:v})}).then(function(r){hint.textContent=r.ok?'保存しました':'保存できませんでした';if(r.ok)setTimeout(function(){if(hint.textContent==='保存しました')hint.textContent='';},1500);}).catch(function(){hint.textContent='保存できませんでした';});}
function mount(){var cd=document.getElementById('CartDrawer');if(!cd)return;var footer=cd.querySelector('.drawer__footer');if(!footer||footer.querySelector('.lj-note'))return;
var box=document.createElement('div');box.className='lj-note';box.innerHTML='<label class="lj-note__label" for="lj-cart-note">ご注文メモ（任意）</label><textarea id="lj-cart-note" class="lj-note__ta" rows="2" maxlength="500" placeholder="配送や商品についてのご要望があればご記入ください"></textarea><p class="lj-note__hint" aria-live="polite"></p>';
footer.insertBefore(box,footer.firstChild);var ta=box.querySelector('textarea'),hint=box.querySelector('.lj-note__hint');
if(TEXT===null){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){TEXT=c.note||'';if(!ta.value)ta.value=TEXT;}).catch(function(){TEXT='';});}else{ta.value=TEXT;}
ta.addEventListener('input',function(){TEXT=ta.value;clearTimeout(timer);timer=setTimeout(function(){save(ta,hint);},800);});
ta.addEventListener('blur',function(){clearTimeout(timer);save(ta,hint);});}
function cartPage(){document.querySelectorAll('#MainContent textarea[name=note]').forEach(function(t){t.setAttribute('placeholder','配送や商品についてのご要望があればご記入ください');t.rows=3;});}
function run(){mount();cartPage();}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
new MutationObserver(function(){run();}).observe(document.documentElement,{childList:true,subtree:true});})();
